import GameSequenceHelper from './game_sequence_helper';
import _ from '../../../utils/underscore';

export default class GameStepReplacer extends GameSequenceHelper {
    static CLASS = 'GameStepReplacer';

    init(params) {
        super.init(params);
        this._createGameStepsCallback = params.createGameStepsCallback;
        this._replacedGameStepPrototype = params.replacedGameStepPrototype;
    }

    With(stepPrototypeOrDescriptor, params) {

        if(_.isArray(stepPrototypeOrDescriptor)) {
            stepPrototypeOrDescriptor.forEach(protOrDescriptor => this._checkIsGameStep(protOrDescriptor));
        } else {
            this._checkIsGameStep(stepPrototypeOrDescriptor);
        }


        let stepIndex = this._findStepIndex(this._replacedGameStepPrototype);
        if(stepIndex < 0) {
            this.throwError('24', `Cannot replace game step of type ${stepPrototypeOrDescriptor} because it cannot be found`);
        }
        let newSteps = this._createGameStepsCallback(stepPrototypeOrDescriptor, params);
        this._currentSteps.splice(stepIndex, 1, ...newSteps);
        return this._createNewGameSequenceBuilder();
    }

}